import { ProductDataType } from "@/api/ProductsApi";
import { DynamicFormFile, DynamicFormRef } from "@mavichpe/dynamic-forms";
import { useRef, useEffect, useState } from "react";
import GenericForm from "@components/forms/GenericForm";
import LoadXmlFormConfig from "./form";
import { showAlert } from "@utils/Alert";
import { xmlToJson } from "@utils/xml";
import { findPropertyRecursive } from "@utils/Utils";
import debounce from "debounce";
import { useAppSelector } from "@/store/hooks";
import { useParams } from "react-router-dom";
import { downloadData } from "aws-amplify/storage";
import { ReceivedAttachmentApi } from "@/api/ReceivedAttachmentApi";
import LoadingScreen from "@components/content/LoadingScreen";

type LoadXmlDataFormProps = {
  onFileLoaded: (json: unknown, receivedEmailId?: string) => void;
  paramLoadable?: boolean;
}

type XmlAssetFormData = Partial<{
  id?: string;
  xml?: DynamicFormFile
}>;

const LoadXmlDataForm = (props: LoadXmlDataFormProps) => {
  const params = useParams()
  const { documentXmlAttachmentId } = params;
  const { onFileLoaded, paramLoadable = false } = props
  const formRef = useRef<DynamicFormRef>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const suscriptionData = useAppSelector(state => state.suscription.suscription);

  const suscriptionRef = useRef<typeof suscriptionData>(suscriptionData);
  useEffect(() => {
    if (paramLoadable && documentXmlAttachmentId) {
      loadAttachmentFromId(documentXmlAttachmentId);
    }
  }, [paramLoadable, documentXmlAttachmentId]);

  useEffect(() => {
    suscriptionRef.current = suscriptionData;
  }, [suscriptionData]);

  const loadAttachmentFromId = async (documentXmlAttachmentId: string) => {
    setIsLoading(true);
    try {
      const xmlFile = await ReceivedAttachmentApi.get(documentXmlAttachmentId);

      const { body } = await downloadData({
        path: `${xmlFile.s3Key}`,
        options: {
          bucket: "recievedProviderEmails"
        }
      }).result;

      const fileXml = await body.text();
      setTimeout(() => {
        loadXmlAndTriggerFileLoaded(fileXml, xmlFile.receivedEmailId)
      },500);

    } catch (err) {
      if (err instanceof Error) {
        showAlert("danger", err.message)
      }
    } finally {
      setIsLoading(false);
    }
  }

  const loadXmlAndTriggerFileLoaded = (xml: string, receivedEmailId?: string) => {
    const json = xmlToJson(xml);

    const receptor = findPropertyRecursive(json, "Receptor")
    if (!receptor) {
      throw Error("El Archivo XML no tiene informacion de Receptor por lo cual no puede ser validado")
    }
    // if (receptor?.Identificacion?.Numero && suscriptionRef.current && suscriptionRef.current.identificacion == receptor?.Identificacion?.Numero) {
    onFileLoaded?.(json, receivedEmailId);
    // } else {
    //   throw Error("La factura electronica enviada no posee el mismo Receptor que la suscripcion actual o la informacion del Numero de Identificacion no se encontro en el documento, por favor verificar")
    // }
  }

  const checkXMLFile = debounce(async (value: any) => {
    try {
      if (value instanceof Array && value.length > 0) {
        const fielData = value as DynamicFormFile[];
        const xmlFile = fielData[0];
        if (!xmlFile?.filePondData?.file) {
          throw Error("Por favor seleccione un archivo")
        }
        if (xmlFile?.filePondData?.file.type != "text/xml") {
          throw Error("Por favor seleccione un archivo xml")
        }

        const xml = await xmlFile.filePondData.file.text();
        loadXmlAndTriggerFileLoaded(xml)
      }
    } catch (error: any) {
      if (error instanceof Error) {
        console.error("Error parseando XML:", error);
        showAlert("danger", error.message);
      }
    }

  }, 300)

  const onInputChange = async (name: keyof XmlAssetFormData, value: any) => {
    if (name == "xml") {
      checkXMLFile(value)
    }
  }

  const loadData = async (data: XmlAssetFormData): Promise<XmlAssetFormData> => {
    return data
  }

  return (
    <>
      {(!documentXmlAttachmentId || !paramLoadable) && (
        <>
          <GenericForm<XmlAssetFormData, ProductDataType>
            ref={formRef}
            formId={"loadXml"}
            formConfig={LoadXmlFormConfig}
            createFn={(...arg) => loadData(...arg)}
            onInputChange={onInputChange}
            successMessage="Los datos del XML han sido cargados correctamente"
            errorMessage="No posible carga la informacion del XML"
          />
          <hr />
        </>
      )}
      <LoadingScreen isLoading={isLoading} />
    </>
  )
}

export default LoadXmlDataForm;